<template>
<div class="form-panel">     
    <div class="form-panel__header">
      <h2 class="titulo-h2">Disfruta de WiFi Gratis</h2>
    </div>
    <div class="form-panel__body">     
      <div class="form-fields"> 
          <siema    class="img-home"
            ref="siema"
            :loop="true"
            :autoplay="true"
        >
            <!-- The Slides -->
            <div>
                <img src="https://clientes.lacentral.com.co/facturas/banner.png" class="img-home">
            </div>
            <div>
                <img src="https://clientes.lacentral.com.co/facturas/banner2.png" class="img-home" >
            </div>
        </siema>
          <div class="form-fields__navegacion">
            <!--<a class="waves-effect waves-light m-btn form-fields__navegacion-der" tabindex="0" href="https://clientes.lacentral.com.co/account/login?wifi=true" target="_blank" >¡Empezar!</a>-->
            <a class="waves-effect waves-light m-btn form-fields__navegacion-der" tabindex="0" @click="acceder()" >¡Empezar!</a>
          </div>     
        </div>     
    </div>      
  </div>   
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  
  computed: {
    ...mapGetters (['token', 'cliente'])
  },
  methods: {
    registro() {
      this.$router.push({ name: 'login' })
    },
    acceder(){
      if(navigator.appVersion.indexOf("Android")!=-1){
        window.location.replace("http://wifi.lacentral.com.co:8089/")  
      }else{
        window.location.replace('https://clientes.lacentral.com.co/account/login?wifi=true');
      }           
    }   
  },
  created() {
    this.$store.estadoWifi = true
    //this.validarBrowser()
    //console.log(storeCliente.state.wifi)
    /*let base_grant_url = this.$route.query.base_grant_url
    let user_continue_url = this.$route.query.user_continue_url

    if(!base_grant_url) {
      this.$router.push({ name: 'home' })
      return
    }

    user_continue_url = "https://www.lacentral.com.co/"
    
    if(storeCliente.state.cliente) {
        let url = base_grant_url + "?continue_url=" + user_continue_url + "&duration=18000"     
        window.location.replace(url)
    }
    else {

      let ultimoIntentoWiFi = localStorage.getItem('ultimoIntentoWiFi')

      let fechaActual = new Date()

      localStorage.setItem('ultimoIntentoWiFi', fechaActual)

      let permitir = true

      if(ultimoIntentoWiFi) {

        let segundos = (fechaActual.getTime() - ultimoIntentoWiFi.getTime()) / 1000

        if(segundos < 1800) {
          permitir = false
          this.$store.dispatch('mostrarMensaje',
          {
            imagen: 'emo-thinking',
            titulo: 'Tiempo Agotado',
            contenido: 'Espera unos minutos para volver a intentar la conexión. Regístrate para evitar interrupciones.'     
          })
        }        
      }

      if(permitir) {
        localStorage.setItem('base_grant_url', base_grant_url)
        localStorage.setItem('user_continue_url', user_continue_url)

        let url = base_grant_url + "?continue_url=https://clientes.lacentral.com.co/mensajeWifiTemporal&duration=1800"     
        window.location.replace(url)
      }
    } */
  },
  
}
</script>
